import { Link } from 'react-router-dom';

interface BlogCardProps {
  title: string;
  slug: string;
  excerpt: string;
  featured_image_url: string;
  category: string;
  author: string;
  published_at: string;
}

export default function BlogCard({ title, slug, excerpt, featured_image_url, category, author, published_at }: BlogCardProps) {
  const date = new Date(published_at).toLocaleDateString('en-CA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <article className="bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-all group">
      <Link to={`/blog/${slug}`} className="block cursor-pointer">
        <div className="aspect-[16/9] overflow-hidden bg-background-100">
          <img
            src={featured_image_url || 'https://readdy.ai/api/search-image?query=modern%20clean%20pharmacy%20healthcare%20blog%20article%20featured%20image%20warm%20neutral%20tones%20soft%20lighting%20professional%20medical%20environment%20editorial%20photography&width=800&height=450&seq=blog-fallback-v1&orientation=landscape'}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            width={800}
            height={450}
            loading="lazy"
            decoding="async"
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs bg-accent-100 text-accent-700 px-2.5 py-1 rounded-full font-medium whitespace-nowrap">{category}</span>
          <span className="text-xs text-foreground-500">{date}</span>
        </div>
        <Link to={`/blog/${slug}`} className="block cursor-pointer">
          <h2 className="text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
            {title}
          </h2>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-4">{excerpt}</p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">By {author}</span>
          <Link
            to={`/blog/${slug}`}
            className="text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            Read More
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}